import * as XLSX from 'xlsx';

const CRUISE_ORDER = ['Sunset Cruise', 'Sundown Cruise', 'Dinner Cruise'];

const COLUMNS = [
  'Adults', 'Child', 'TL', 'Deck', 'Booking Name', 'Partner Name', 'Phone Number',
  'Total', 'TAC', 'Net Total', 'Cruise Type', 'Payment Status',
  'Razorpay', 'Cash', 'ICICI POS', 'Bank Transfer', 'GPay',
  'Tickets', 'Notes', 'Driver Commission', 'Check', 'Guest Ticket',
];

const PAYMENT_COLS = ['Razorpay', 'Cash', 'ICICI POS', 'Bank Transfer', 'GPay'];

export function exportBookingsToExcel(bookings, date) {
  const sorted = [...bookings].sort(
    (a, b) => CRUISE_ORDER.indexOf(a.cruise_type) - CRUISE_ORDER.indexOf(b.cruise_type)
  );

  const rows = sorted.map((b) => {
    const row = {
      Adults: b.adults,
      Child: b.children || 0,
      TL: b.tour_leaders || 0,
      Deck: b.deck,
      'Booking Name': b.booking_name,
      'Partner Name': b.partner_name || '',
      'Phone Number': b.guest_phone || '',
      Total: b.total_amount,
      TAC: b.tac || 0,
      'Net Total': b.net_total,
      'Cruise Type': b.cruise_type,
      'Payment Status': b.payment_status || '',
      Razorpay: '',
      Cash: '',
      'ICICI POS': '',
      'Bank Transfer': '',
      GPay: '',
      Tickets: '',
      Notes: b.notes || '',
      'Driver Commission': '',
      Check: '',
      'Guest Ticket': '',
    };

    if (b.payment_mode && PAYMENT_COLS.includes(b.payment_mode)) {
      row[b.payment_mode] = b.total_amount;
    }

    return row;
  });

  const ws = XLSX.utils.json_to_sheet(rows, { header: COLUMNS });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Bookings');

  const fileName = `Alfresco_Bookings_${date.replace(/-/g, '_')}.xlsx`;
  XLSX.writeFile(wb, fileName);
}
